import firebase from "../firebase";

export default function({ officeId, visitId, roomId }) {
    return firebase.functions().httpsCallable("allFunctions")({
        funcRole: "patientTrackingUser",
        funcName: "moveToRoom",
        data: { officeId, visitId, roomId }
    });
}
